import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import waglMascot from './assets/images/wagl-mascot-illustration@2x.png';
import heroBG from './assets/images/homepage-hero-bg.svg';

const Home = ({ storage }) => {
  const ENABLE_CHATBOT = false;
  return (
    <Box
      sx={{
        backgroundImage: `url(${heroBG})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center' }}>
          <img src={waglMascot} alt="Wagl mascot" width="222" />
          <Typography variant="h3" component="h1" gutterBottom>
            Hey 👋 I'm Wagl! <br />I take the pain out of organising Golf.
          </Typography>
        </Box>
        {ENABLE_CHATBOT && <Paper>Create a game for this Saturday at St Andrews</Paper>}
      </Container>
    </Box>
  );
};

export default Home;
